<div class="py-2 px-2 py-md-5 px-md-5">
    <div class="row">
        <div class="col-md-6">
            <mat-card class="bg-white mat-elevation-z3">
                <div class="row">
                    <div class="col-md-6">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-icon class="mx-1" color="primary">task</mat-icon>
                                Aktualizacja zadania
                            </mat-card-title>
                            <mat-card-subtitle>Aktualizuj nazwę lub opis zadania.</mat-card-subtitle>
                        </mat-card-header>
                    </div>
                </div>
                <mat-card-content>
                    <div class="pt-2">
                        <app-task-form [task]="task" [editMode]="true" #data></app-task-form>
                        <app-form-save-button [invalid]="data.taskForm.invalid"
                                              (closeForm)="closeForm()"
                                              (save)="updateTask()"></app-form-save-button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
